import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { LogEntryPage } from 'pages/logbook/LogEntryPage'
import { z } from 'zod'

export const Route = createFileRoute('/logbook/entry/$logEntryId')({
  validateSearch: z.object({ logTemplateId: z.string().optional() }),
  component: RouteComponent,
  staticData: {
    title: 'Log Entry',
  },
})

function RouteComponent() {
  const { logEntryId } = Route.useParams()
  const { logTemplateId } = Route.useSearch()
  const navigate = useNavigate()

  return (
    <LogEntryPage
      logEntryId={logEntryId}
      logTemplateId={logTemplateId}
      onDone={() => navigate({ to: '/logbook', search: {} })}
    />
  )
}
